import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { get, identity } from 'lodash'

import Checkbox from '../../Checkbox'
import { flatFiltersValues } from '../utils'

const SelectAllCheckbox = ({
  t,
  filters,
  hierarchy,
  onCheckboxClick,
  withLabel
}) => {
  const checkboxStatus = useMemo(() => {
    const accordionFilters = get(filters, hierarchy, {})

    const filterValues = Object.values(accordionFilters)
    const flattenValues = flatFiltersValues(filterValues)

    if (flattenValues.every(Boolean)) {
      return { checked: true }
    }

    return flattenValues.some(Boolean)
      ? { indeterminate: true }
      : { checked: false }
  }, [filters, hierarchy])

  return (
    <Checkbox
      labelText={withLabel ? t('SELECT_ALL') : ''}
      id={`${hierarchy.join()}-select-all`}
      onChange={onCheckboxClick}
      onClick={(e) => e.stopPropagation()}
      {...checkboxStatus}
    />
  )
}

SelectAllCheckbox.propTypes = {
  t: PropTypes.func,
  filters: PropTypes.object.isRequired,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
  onCheckboxClick: PropTypes.func,
  withLabel: PropTypes.bool
}

SelectAllCheckbox.defaultProps = {
  t: identity,
  hierarchy: [],
  onCheckboxClick: identity,
  withLabel: false
}

export default React.memo(SelectAllCheckbox)
